import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Convert.css';

function Convert() {
  const navigate = useNavigate();

  const handleOptionClick = (type) => {
    navigate(`/convert/${type}`);
  };

  return (
    <div className="convert-page">
      <div className="container">
        <h1>Convert Your Airtime or Points to Money</h1>
        <p className="subtitle">Select the type you want to convert:</p>
        
        <div className="conversion-options">
          <div className="option" 
               onClick={() => handleOptionClick('safaricom')}>
            <div className="option-logo safaricom-logo"></div>
            <h3>CONVERT SAFARICOM AIRTIME TO MONEY</h3>
            <p>Swap your Safaricom Airtime for Money at ~ 90.00% rate.</p>
          </div>
          
          <div className="option"
               onClick={() => handleOptionClick('airtel')}>
            <div className="option-logo airtel-logo"></div>
            <h3>CONVERT AIRTEL AIRTIME TO MONEY</h3>
            <p>Swap your Airtel Airtime for Money at ~ 80.00% rate.</p>
          </div>
          
          <div className="option"
               onClick={() => handleOptionClick('bonga')}>
            <div className="option-logo bonga-logo"></div>
            <h3>CONVERT BONGA POINTS TO MONEY</h3>
            <p>Swap your Bonga points for Money at competitive rates.</p>
          </div>
        </div>
        
        {/* Form removed from this page */}
      </div>
    </div>
  );
}

export default Convert;
